import { ReactNode } from "react";
import {
  PickerUser,
  UserPickerDialog,
} from "@/components/user-selector";
import type { RoleValue } from "@/lib/swr";

export type UsersSelectorProps = {
  selectedUsers?: PickerUser[];
  onContinue: (users: PickerUser[]) => void;
  buttonText?: ReactNode;
  hideUsers?: PickerUser[];
  className?: string;
  icon?: ReactNode;
  trigger?: ReactNode;
  /** Default to users holding one of these roles, with a "Show all" escape hatch. */
  roleFilter?: RoleValue[];
  /** Candidate-list endpoint and hint (see UserPickerDialog). */
  sourceUrl?: string;
  hint?: string;
};

// Multi-user picker. Shares UserPickerDialog with the single UserSelector.
export function UsersSelector({
  selectedUsers,
  onContinue,
  ...rest
}: UsersSelectorProps) {
  return (
    <UserPickerDialog
      multiple
      selected={selectedUsers ?? []}
      onConfirm={onContinue}
      title="Select users"
      description="Select users to add to this thread."
      {...rest}
    />
  );
}

export default UsersSelector;
